import React from "react";
import { DatePicker, Empty } from "antd";
import "./CustomRangeSelector.scss";
const { RangePicker } = DatePicker;

const CustomRangeSelector = ({ dateRange, handleDateChange }) => {
  return (
    <div className="date-input">
      <RangePicker
        value={dateRange}
        onChange={handleDateChange}
        placeholder={["Start Date", "End Date"]}
        format="YYYY-MM-DD"
        style={{ width: "280px" }}
      />
    </div>
  );
};

export default CustomRangeSelector;
